import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetPqrReceivedThroughHistorical,
    asyncGetPqrReceivedThroughWithAlertTemplate,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { PQR_RECEIVED_THROUGH } from '../../../../../routes/paths';

export const usePqrReceivedThroughDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idReceivedThrough } = useParams();
    const [loading, setLoading] = useState(false);
    const [pqrReceivedThrough, setPqrReceivedThrough] = useState<Param>();
    const [pqrReceivedThroughHistorical, setPqrReceivedThroughHistorical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idReceivedThrough)) {
            setLoading(true);
            asyncGetPqrReceivedThroughWithAlertTemplate(idReceivedThrough)
                .then((pqrReceivedThrough: any) => {
                    if (!pqrReceivedThrough) navigate(PQR_RECEIVED_THROUGH);
                    setPqrReceivedThrough(pqrReceivedThrough);
                })
                .finally(() => setLoading(false));
        }
    }, [idReceivedThrough]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetPqrReceivedThroughHistorical(idReceivedThrough)
                .then((resp) => {
                    if (resp) setPqrReceivedThroughHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        pqrReceivedThrough,
        pqrReceivedThroughHistorical,
        showHistorical,
        setShowHistorical,
    };
};
